<button
  class="button quaternary danger"
  cdkMenuItem
  (click)="leaveDialog.showModal()">
  <div class="icon icon-trash"></div>
  <span>Leave this trip</span>
</button>
<dialog class="modal-dialog at-dialog" #leaveDialog style="max-width: 420px">
  <h2 class="dialog-header heading-2xl">
    Leave &quot;{{ trip().title }}&quot;
  </h2>
  @if (state()?.isLoading) {
    <div class="empty-content">
      <div class="loading-spinner"></div>
      <p class="body-copy-md">Leaving trip...</p>
    </div>
  } @else {
    <p class="at-dialog-content body-copy-md">
      Are you sure you want to leave this trip? This action can't be undone.
    </p>
    <p class="at-dialog-content body-copy-sm">
      You can always rejoin the trip later by requesting a link to the owner.
    </p>
  }
  <div class="at-dialog-actions">
    <button class="button primary danger" (click)="leaveTrip.next()">
      Leave trip
    </button>
    <button class="button quaternary" (click)="leaveDialog.close()">
      Stay in trip
    </button>
  </div>
</dialog>
